module.exports = "/_next/static/images/27e194c8ca81478c32a860730aefb17f-background-xs.png.webp";